import { ZenityUserRoleEnum } from '../api/accountManagement.model';
import { FilterTypesEnum } from '../filters/filterTypes.enum';
import { ISelectOption } from './selectOption.interface';

export const RoleSelectOptions: ISelectOption[] = [
  {
    id: `${FilterTypesEnum.Role.toString()}-${ZenityUserRoleEnum.admin}`,
    value: ZenityUserRoleEnum.admin,
    displayName: ZenityUserRoleEnum.admin,
    filterType: FilterTypesEnum.Role,
  },
  {
    id: `${FilterTypesEnum.Role.toString()}-${ZenityUserRoleEnum.operator}`,
    value: ZenityUserRoleEnum.operator,
    displayName: ZenityUserRoleEnum.operator,
    filterType: FilterTypesEnum.Role,
  },
  {
    id: `${FilterTypesEnum.Role.toString()}-${ZenityUserRoleEnum.analyst}`,
    value: ZenityUserRoleEnum.analyst,
    displayName: ZenityUserRoleEnum.analyst,
    filterType: FilterTypesEnum.Role,
  },
  {
    id: `${FilterTypesEnum.Role.toString()}-${ZenityUserRoleEnum.viewer}`,
    value: ZenityUserRoleEnum.viewer,
    displayName: ZenityUserRoleEnum.viewer,
    filterType: FilterTypesEnum.Role,
  },
];
